import { render, staticRenderFns } from "./VerDetalleRecargoModal.vue?vue&type=template&id=1085f2b4"
import script from "./VerDetalleRecargoModal.vue?vue&type=script&lang=js"
export * from "./VerDetalleRecargoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports